/* eslint-disable max-len */
import {
  defineComponent, ref, onMounted, computed,
} from 'vue';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getStylesBinder } from '../../common/utils/styles';
import styles from './index.module.less';
import { fetchFreeComposeProductsList } from '../../model/apis/ticketApis';
import { appQueryConfig } from '../../common/utils/url';
import { uiMgr } from '../../common/uiMgr';

const cx = getStylesBinder(styles);

export default defineComponent({
  name: 'MixAddGoods',
  setup: () => {
    const freeComposeProductAList = ref<any[]>([]);
    const freeComposeProductBList = ref<any[]>([]);

    const fetchFreeComposeProducts = async () => {
      try {
        const res = await fetchFreeComposeProductsList({
          isUseAlgorithmB: true,
          isUseAlgorithmA: true,
        });
        freeComposeProductAList.value = res.data.itemAList || [];
        freeComposeProductBList.value = res.data.itemBList || [];
      } catch (error) {
        console.log('fetchFreeComposeProducts error', error);
      }
    };

    onMounted(() => {
      fetchFreeComposeProducts();

      UBT.moduleExpose({
        pageId: 'platform_couponmall',
        categoryId: 'platform',
        moduleId: 'platform_couponFreeCompose',
        contentId: 'platform_couponFreeCompose',
        exposureTimes: 1,
        businessInfo: {
          adsource: appQueryConfig.adsource,
        },
      });
    });

    const handleGoto = () => {
      UBT.clickButton({
        pageId: 'platform_couponmall',
        buttonName: 'platform_couponFreeCompose',
        categoryId: 'platform',
        businessInfo: {
          adsource: appQueryConfig.adsource,
        },
      });
      uiMgr.pushPage({
        name: 'CouponFreeCompose',
        query: {
          adsource: 'couponMallList',
        },
      });
    };

    // 安全计算总价格，先分别转整数再相加，避免浮点数精度问题
    const totalPrice = computed(() => {
      const priceA = +(freeComposeProductAList.value[0]?.salePrice || 0);
      const priceB = +(freeComposeProductBList.value[0]?.salePrice || 0);
      // 修正点：乘 100 后必须 Math.round，消除如 1.13 * 100 = 112.999... 的误差
      const centA = Math.round(priceA * 100);
      const centB = Math.round(priceB * 100);

      return (centA + centB) / 100;
    });

    const originalPrice = computed(() => {
      const priceA = +(freeComposeProductAList.value[0]?.originalPrice || 0);
      const priceB = +(freeComposeProductBList.value[0]?.originalPrice || 0);
      const centA = Math.round(priceA * 100);
      const centB = Math.round(priceB * 100);
      return (centA + centB) / 100;
    });

    return () => (freeComposeProductAList.value.length > 0
      && freeComposeProductBList.value.length > 0 ? (
        <div class={cx('container')} onClick={handleGoto}>
          <div class={cx('top')}>
            <img
              class={cx('header-icon')}
              src="https://m.hellobike.com/9b325df4_Frame%202117131404.png"
              alt=""
            />
            <div class={cx('more')}>
              <span>随心搭配，最低1元起</span>
              <img
                class={cx('more-icon')}
                src="https://m.hellobike.com/helloyun3/28831/lkpxd9cm_yyy_black.svg"
                alt=""
              />
            </div>
          </div>
          <div class={cx('bottom')}>
            <div class={cx('card-item')}>
              <div class={cx('card-item-left')}>
                <div class={cx('card-item-left-text')}>
                  <span class={cx('card-item-left-text-price')}>
                    {freeComposeProductAList.value[0].originalPrice}
                  </span>
                  元
                </div>
                <div class={cx('card-item-left-desc')}>
                  {freeComposeProductAList.value[0].businessName}
                </div>
              </div>
              <div class={cx('card-item-right')}>
                <div class={cx('card-item-right-text')}>
                  <span class={cx('card-item-right-text-price')}>
                    {freeComposeProductBList.value[0].originalPrice}
                  </span>
                  元
                </div>
                <div class={cx('card-item-right-desc')}>
                  {freeComposeProductBList.value[0].businessName}
                </div>
              </div>
              <div class={cx('card-item-icon-add')}>
                <img
                  class={cx('card-item-icon-add-icon')}
                  src="https://m.hellobike.com/e48b6d06_%2B.svg"
                  alt=""
                />
              </div>
            </div>
            <div class={cx('sum')}>=</div>
            <div class={cx('buy-container')}>
              <div class={cx('price-box')}>
                <span class={cx('price-left')}>
                  <span class={cx('price-unit')}>¥</span>
                  {totalPrice.value}
                </span>
                <span class={cx('price-right')}>¥{originalPrice.value}</span>
              </div>
              <div class={cx('btn')}>去选购</div>
            </div>
          </div>
        </div>
      ) : (
        <div class={cx('container-empty')}></div>
      ));
  },
});
